export default __webpack_public_path__ + "static/media/logo-rpc-full.b238d812.png";